/**
 * Created by USER on 18/7/26.
 */
import React, { Component } from 'react';

export default class SingleMembers extends Component {
  render() {
    const {img, name, notice} = this.props;
    return (
      <div className="single_members">
        <img src={img} alt="LUBANSO" />
        <div className="single_members_name">{name}</div>
        <div className="single_members_notice">{notice}</div>
      </div>
    );
  }
}
